import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-tinymcehtmleditor',
  templateUrl: './tinymcehtmleditor.component.html',
  styleUrls: ['./tinymcehtmleditor.component.scss']
})
export class TinymcehtmleditorComponent {

    @Input() html = '';

    @Input() htmlForm?: FormGroup;

    constructor(private _fb:FormBuilder) {

    }

    get htmlElement() {
        return this.html;
    }

}
